module.exports = __webpack_public_path__ + "static/media/6.91e2cf91.jpeg";